export default __webpack_public_path__ + "static/media/fondo.eb1d9520.jpg";